export const dayInMs = 1000 * 60 * 60 * 24;
export const secondInMs = 1000;
